<template>
    <div v-on-click-outside="closeDropdown" class="relative">
        <div
            data-cy="dropdown-button"
            @click="toggleDropdown()"
        >
            <slot name="button"/>
        </div>

        <div
            v-show="showDropdown"
            class="rounded-b-xl shadow-2xl"
            :class="dropdownStyling"
        >
            <slot name="dropdown" :close="closeDropdown"/>
        </div>
    </div>
</template>


<script lang="ts" setup>
import {vOnClickOutside} from '@vueuse/components'
import {computed, PropType} from 'vue'
import {useToggle} from '@vueuse/core'

const props = defineProps({
    topBar: Boolean,
    direction: {
        type: String as PropType<'left' | 'right'>,
        default: 'right'
    },
    panelChooser: Boolean
})

const [showDropdown, toggleDropdown] = useToggle()
const dropdownStyling = computed(() => {
    const baseStyling = props.direction === 'right' ? 'drop-down' : 'drop-down drop-down-end'
    return !props.topBar ? 'top-9 left-1 pt-2 pl-4 pr-10 pb-10 ' + baseStyling : 'top-[48px] shadow-md ' + baseStyling
})

const closeDropdown = () => {
    showDropdown.value = false
}

const openDropdown = () => {
    showDropdown.value = true
}

defineExpose({openDropdown, closeDropdown, toggleDropdown})

</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

.drop-down {
    max-height: calc(100vh - 110px);
    overflow-y: auto !important;
    @apply absolute z-50 bg-base-100 truncate
}

.drop-down-end {
    @apply right-0
}

.org-selector {
    @apply absolute z-50 shadow-md border border-base-300 bg-base-100 overflow-y-scroll max-h-[80%] h-fit w-[20%]
}
</style>